"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hybridizations = exports.ErrorColors = exports.Errors = exports.DefaultTolerance = void 0;
// error colors in priority order
const ErrorColors = [
    { key: 'outOfLimit', color: 'red' },
    { key: 'ambiguousAttachment', color: 'orange' },
    { key: 'notAttached', color: 'blue' },
    { key: 'incomplete', color: 'red' },
];
exports.ErrorColors = ErrorColors;
const Errors = ErrorColors.map((errorColor) => errorColor.key);
exports.Errors = Errors;
const Hybridizations = [
    {
        key: '-',
        label: '',
        value: '',
    },
    {
        key: 'sp',
        label: 'sp',
        value: 'SP',
    },
    {
        key: 'sp2',
        label: 'sp2',
        value: 'SP2',
    },
    {
        key: 'sp3',
        label: 'sp3',
        value: 'SP3',
    },
];
exports.Hybridizations = Hybridizations;
const DefaultTolerance = {
    C: 0.25,
    H: 0.02,
    N: 0.25,
    F: 0.25,
    Si: 0.25,
    P: 0.25,
};
exports.DefaultTolerance = DefaultTolerance;
